import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseDiscountDeletedTemplates = [
  {
    id: '-213001',
    language: Language.EN,
    subject: 'Lease discount interruption',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_DISCOUNT_DELETED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Dear tenant,</p>
          <p>There is a discount interruption on your lease.</p>
          <p>More details here : {{pdfLink}}.</p>
          <p>Kind regards.</p>
      `,
  },
  {
    id: '-213002',
    language: Language.FR,
    subject: 'Interruption de remise sur bail',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_DISCOUNT_DELETED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Cher/Chère locataire,</p>
          <p>Une remise relative à votre bail a été interrompue.</p>
          <p>Plus de détails ici: {{pdfLink}}.</p>
          <p>Bien à vous.</p>
      `,
  },
  {
    id: '-213003',
    language: Language.NL,
    subject: 'Intrekking van een huurkorting',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_DISCOUNT_DELETED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Beste huurder,</p>
          <p>Een korting op uw huurovereenkomst is stopgezet.</p>
          <p>Meer details hier: {{pdfLink}}.</p>
          <p>Groeten.</p>
      `,
  },
  {
    id: '-213004',
    language: Language.DE,
    subject: 'Unterbrechung des Mietrabatts',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_DISCOUNT_DELETED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Sehr geehrte/r Mieter/in,</p>
          <p>Ein Rabatt in Ihrem Mietvertrag wurde unterbrochen.</p>
          <p>Weitere Details hier: {{pdfLink}}.</p>
          <p>Mit freundlichen Grüßen.</p>
      `,
  },
];
